export default __webpack_public_path__ + "static/media/Proprioception.9f5f9108.jpg";